export const CUSTOMER_TAB = {
  title: "Customer",
  apiRequestPortal: "customer",
  forgotPasswordApiParam: "Customer",
  isCustomer: true,
};
export const EMPLOYEE_TAB = {
  title: "Employee",
  apiRequestPortal: "employee",
  forgotPasswordApiParam: "Employee",
  isCustomer: false,
};
export const LOGIN_TABS = [CUSTOMER_TAB, EMPLOYEE_TAB];
export const FORM_DEFAULT_VALUES = {
  email: "",
  password: "",
};
